import { TimeKeepingRecords } from '@/features/broadcast-schedule-program/components/BroadcastScheduleProgramBody/components/BroadcastScheduleProgramBodySegmentToolkit/components/BroadcastScheduleProgramBodySegmentToolkitTimeKeeping/types';
import { TClipPeople } from '@/features/clips/types';
import { EVisibility } from '@/types/types';

export const buildRecordsFromPeople = (entries: TClipPeople[]): TimeKeepingRecords[] =>
  entries.map(entry => ({
    id: entry.id,
    visibility: entry.parameters?.visibility ?? EVisibility.MEDIA,
    datetimeStart: entry.start_datetime,
    datetimeEnd: entry.end_datetime,
  }));
